angular.module('env.data.services.cookies', [])

    .service('cookiesService', function ($log, $q, $localStorage, authService, userSettings, gettextCatalog, toastr) {
        var _this = this;
        var FIRST_RUN_TOKEN = "FirstRun";
        
        /**
         * Ping server
         * @returns {Promise}
         */
        _this.showCookiesPolicyMessage = function () {
            userSettings.getSettings().then(function(settings) {
                //if we have our app configured to show cookie policy warning
                if (settings && settings.disableCookiePolicyWarning === true) {
                    return;
                }

                if ($localStorage.getItem(FIRST_RUN_TOKEN) === null) {
                    var cookiePolicyMessage = gettextCatalog.getString('AuthPopup.CookieStatement');
                    toastr.warning(cookiePolicyMessage, gettextCatalog.getString('OrderManager Cookie Policy'), { timeOut: 0, extendedTimeOut: 0 });
                    $localStorage.setItem(FIRST_RUN_TOKEN, authService.getUsername());
                }
            });
        };

        return _this;
    })

;
